import React from "react";
import "../../App.css";

export function GameShell({
  width,
  board,
  desktopSidebar,
  mobileSidebar = null,
  footer = null,
  belowShell = null,
  appClassName = "",
  shellClassName = "",
}) {
  const boardClassName = shellClassName
    ? `game-board ${shellClassName}`
    : "game-board";
  const rootClassName = appClassName ? `App ${appClassName}` : "App";

  return (
    <div className={rootClassName}>
      <div className={boardClassName}>
        <div className="game-container">
          {board}
          {width >= 768 && footer}
        </div>

        {width < 768 ? (
          <>
            {mobileSidebar}
            {footer}
          </>
        ) : (
          desktopSidebar
        )}
      </div>
      {belowShell}
    </div>
  );
}
